import { SLATE_VOID_ELEMENT } from 'src/lib/slate';

export const withDividers = (editor) => {
  const { isVoid } = editor;

  editor.isVoid = (element) => {
    return element.type === SLATE_VOID_ELEMENT.DIVIDER ? true : isVoid(element);
  };

  return editor;
};
